var React = require('react');

function MoreHorizontal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M53.2,112.2c-16.3,0-29.5,13.2-29.5,29.5s13.2,29.5,29.5,29.5s29.5-13.2,29.5-29.5S69.5,112.2,53.2,112.2z M230.2,112.2\n\tc-16.3,0-29.5,13.2-29.5,29.5s13.2,29.5,29.5,29.5s29.5-13.2,29.5-29.5S246.5,112.2,230.2,112.2z M141.7,112.2\n\tc-16.3,0-29.5,13.2-29.5,29.5s13.2,29.5,29.5,29.5s29.5-13.2,29.5-29.5S158,112.2,141.7,112.2z"}));
}

MoreHorizontal.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 283.5 283.5","style":{"enableBackground":"new 0 0 283.5 283.5"},"xmlSpace":"preserve"};

module.exports = MoreHorizontal;

MoreHorizontal.default = MoreHorizontal;
